import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { HttpService } from 'src/app/service/http/http.service';

import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { LoaderService } from 'src/app/service/loader/loader.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-elcm-exit-pop-up',
  templateUrl: './elcm-exit-pop-up.component.html',
  styleUrls: ['./elcm-exit-pop-up.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ElcmExitPopUpComponent implements OnInit {

  buttonColorName: any;
  loggedInUserRole: any;
  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any
  selectedYear: any;
  pmsYears: any = [];
  loggedInUserId: any;
  fromYear: any;
  toYear: any;
  from: any;
  getChangedData: any;
  loggedInUserEmployeeCode: any;
  reportingManager: any;
  confirmationProbationWhomSetup: any;
  userEmail: any;
  isToggleOn: boolean = true;
  type: any = 'Resigned';
  type1: any = 'Regate';
  type2: any = 'Accepted';
  type3: any = 'Terminated'
  tab: any;
  listofData: any = []
  currentlistofData: any = []
  constructor(private datePipe: DatePipe,

    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public Employeedata: any,
    private activatedroute: ActivatedRoute,
    private encryptionService: EncryptionService,
    private loader: LoaderService,

  ) {
    console.log(Employeedata);
    this.currentlistofData = Employeedata.userID;
    this.tab = Employeedata.tab.ModuleName
  }

  ngOnInit() {

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserEmployeeCode = sessionStorage.getItem('empCode');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.userEmail = sessionStorage.getItem('userEmail');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getChangedData = sessionStorage.getItem('ProbassionChangedData');

    this.reportingManager = this.httpService.reportingManagerForElcm;
    this.confirmationProbationWhomSetup = this.httpService.confirmationProbationWhomSetup;
    this.manageData();
  }

  ExitTableHeader = [

    { label: "Emp Code", maxWidth: "180px" },
    { label: "Name", maxWidth: "180px" },
    { label: "Manager name ", maxWidth: "180px" },
    { label: "HOD name", maxWidth: "180px" },
    { label: "Dept", maxWidth: "180px" },
    { label: "Band", maxWidth: "180px" },
    { label: " Grade", maxWidth: "180px" },
    { label: " Designation", maxWidth: "180px" },
    { label: "DOR ", maxWidth: "180px" },
    { label: "Employement", maxWidth: "180px" },
    { label: "Notice period", maxWidth: "180px" },
    { label: "LWD", maxWidth: "180px" },

  ];
  terminateTableHeader = [

    { label: "Emp Code", maxWidth: "180px" },
    { label: "Name", maxWidth: "180px" },

    { label: "Dept", maxWidth: "180px" },
    { label: "Band", maxWidth: "180px" },
    { label: " Designation", maxWidth: "180px" },
    { label: "DOT", maxWidth: "180px" },
    { label: "LWD", maxWidth: "180px" },

  ];
  onChangeSwitch(event: any) {
    this.isToggleOn = event?.checked;
    if (this.tab === 'Resigned Emp') {

      this.type = this.isToggleOn ? 'Resigned' : 'Withdrawal';
    } else if (this.tab === 'Regrettable Emp') {
      this.type1 = this.isToggleOn ? 'Regate' : 'Non-Regate';
    }
    else if (this.tab === 'Resignation Accepted Emp') {
      this.type2 = this.isToggleOn ? 'Accepted' : 'Rejected';
    }
    else if (this.tab === 'Terminated Emp') {
      this.type3 = this.isToggleOn ? 'Terminated' : 'Revoke';
    }

    // If tab is 'Resigned Emp', keep the same type logic (already handled above)

    this.manageData();
  }
  filterData: any;

  manageData() {
    if (this.tab === 'Resigned Emp') {
      if (this.type == 'Withdrawal') {
        let data = this.currentlistofData.filter((elm: any) => elm.withdrawalReason !== '' && elm.withdrawalReason !== null);
        this.listofData = data;
        this.filterData = data
      } else {
        let data = this.currentlistofData.filter((elm: any) => elm.withdrawalReason == '' || elm.withdrawalReason == null);
        this.listofData = data;
        this.filterData = data
      }
    }
    else if (this.tab === 'Regrettable Emp') {
      if (this.type1 == 'Regate') {
        let data = this.currentlistofData.filter(
          (elm: any) => elm.regretType === "Yes" && elm.withdrawalReason == null
        );

        this.listofData = data;
        this.filterData = data;
      } else {
        let data = this.currentlistofData.filter((elm: any) => elm.regretType == "No");
        this.listofData = data;
        this.filterData = data
      }
    }
    else if (this.tab === 'Resignation Accepted Emp') {
      if (this.type2 == 'Accepted') {
        let data = this.currentlistofData.filter((elm: any) =>
          elm.approvalStatus == "APPROVED" &&
          (elm.withdrawalReason == '' || elm.withdrawalReason == null)

        );
        this.listofData = data;
        this.filterData = data
      } else {
        let data = this.currentlistofData.filter((elm: any) => elm.approvalStatus == "REJECTED" && (elm.withdrawalReason == '' || elm.withdrawalReason == null));
        this.listofData = data;
        this.filterData = data
      }
    } else {
      if (this.type3 == 'Terminated') {
        let data = this.currentlistofData.filter((elm: any) => elm.revolveStatus == false);
        this.listofData = data;
        this.filterData = data
      } else {
        let data = this.currentlistofData.filter((elm: any) => elm.revolveStatus == true);
        this.listofData = data;
        this.filterData = data
      }
    }
  }

  DislaySelectedRecord(event: any) {
    this.listofData = this.filterData.slice(0, event.value);
  }

  searchTerm: any = ''; // Holds search input value
  filteredEmployees: any[] = []; // Holds filtered employee list

  filterEmployees() {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      // Reset to the original full list
      this.listofData = [...this.filterData];
      return;
    }
    const searchTextLower = this.searchTerm.toLowerCase().trim();

    let data = this.filterData.filter((employee: any) =>
      Object.values(employee).some(value => {
        if (value === null || value === undefined) return false; // Skip null/undefined
        return value.toString().toLowerCase().includes(searchTextLower);
      })
    );


    this.listofData = data;


  }

  formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const day = ('0' + d.getDate()).slice(-2);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  downloadExitList() {
    const headers = [
      'Emp Code', 'Name', 'Manager Name', 'HOD Name', 'Department',
      'Band', 'Grade', 'Designation', 'Resign Date', 'Employment Type', 'Notice Period', 'LWD'
    ];

    this.downloadCSVFile(
      'EmployeeExitList.csv',
      headers,
      this.listofData,
      (item) => [
        item.empCode,
        item.empName,
        item.managerFullName,
        item.hodFullName,
        item.empDepartment,
        item.empBand,
        item.empGrade,
        item.empDesignation,
        item.resignDate,
        item.employmentType,
        item.noticePeriod,
        item.lastWorkingDay
      ]
    );
  }
  downloadCSVFile(filename: string, headers: string[], data: any[], rowMapper: (item: any) => string[]) {
    if (!data || data.length === 0) {
      return;
    }

    const csvRows = [
      headers.join(','), // Header row
      ...data.map(item => rowMapper(item).join(','))
    ];

    const csvData = csvRows.join('\n');
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  downloadTerminateList() {
    const headers = [
      'Employee Code', 'Employee Name', 'Department',
      'Band', 'Designation', 'DOT', 'LWD'
    ];

    this.downloadCSVFile(
      'TerminatedEmployeeList.csv',
      headers,
      this.listofData,
      (item) => [
        item.empCode || '',
        item.empName || '',
        item.empDepartment || '',
        item.empBand || '',
        item.empDesignation || '',
        this.formatDate(item.dateOfTermination),
        this.formatDate(item.lastWorkingDay)
      ]
    );
  }





}
